<template>
  <div id="app">
    <TitleHeader />
    <TempAna v-if="ana === false" @clicked="run()" />
    <HelloWorld v-else  />
    <FooterComp />
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld'
import TitleHeader from './components/TitleHeader'
import FooterComp from './components/FooterComp'
import TempAna from './components/TempAna'

export default {
  name: 'app',
  data () {
    return {
      ana: false
    }
  },
  methods: {
    run () {
      this.ana = true
    }
  },
  components: {
    HelloWorld,
    TitleHeader,
    FooterComp,
    TempAna
  }
}
</script>

<style>
body, html {
  padding: 0;
  margin: 0;
}
#app {
  /*
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -ms-flex-align: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  */
  padding-top: 65px;
  align-items: center;
  content-just
  padding: 0;
  margin: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 80%;
  background-color: #fff;
}
.section {
  
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  height: 60vh;
  width: 75%;
  margin: auto;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  
  align-items: center;
}
.col {
  width: 50%;
  height: 100%;
  min-height: 400px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  text-align: center;
  align-items: center;
  margin-top: 10vh;
}
.content {
  font-size: 3vh;
  margin: auto;
  width: 80%;
  text-align: left;
}
.button {
  background-color: #267df4;
  border-radius: 100px;
  display: inline-block;
  padding: 10px 30px;
  color: #fff;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 1px;
  cursor: pointer;
}
.button:hover {
  opacity: 0.8;
}
@media only screen and (max-width: 1400px) {
  .content {
    width: 90%;
  }
  .section {
    width: 85%;
  }
}
@media only screen and (max-width: 900px) {
  .content {
    width: 90%;
  }
  .section {
    width: 100%;
    display: block;
    height: auto;
  }
  .col {
    height: auto;
    min-height: 200px;
    width: 100vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue